<div class="container d-flex flex-column h-100">
  <div class="d-flex flex-column flex-grow-1">
    <div class="d-flex justify-content-center">
      <h3>Select Third Party Provider</h3>
    </div>
    <mat-divider class="mb-3"></mat-divider>
    <form [formGroup]="provider">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Company Name of the 3rd Party</mat-label>
        <input #providerNameInput ngSpecialCharacter [regex]="pattern" formControlName="providerCompany" matInput
               (keyup)="searchProviderName.next(providerNameInput.value)"/>
        <mat-error *ngIf="provider.controls.providerCompany.errors">
          This field is required
        </mat-error>
        <mat-icon *ngIf="!providerNameInput.value" fontSet="fas" fontIcon="fa-search" inline matSuffix></mat-icon>
        <button class="align-bottom" mat-icon-button *ngIf="providerNameInput.value" matSuffix aria-label="Clear"
                (click)="clearText()">
          <mat-icon fontSet="fas" fontIcon="fa-times" inline></mat-icon>
        </button>
      </mat-form-field>
    </form>
    <div class="row no-gutters font-weight-bold list-headers">
      <div class="col-6">Name</div>
      <div class="col-6">Customer Number</div>
    </div>
    <div class="list-container flex-grow-1 overflow-auto border rounded">
      <mat-divider></mat-divider>
      <ng-container *ngIf="!isLoading && companyProviders && companyProviders.length > 0">
        <mat-selection-list dense multiple="false" role="list" class="mb-3">
          <mat-list-option #companyProvidersCheck *ngFor="let cmp of companyProviders" [value]="cmp" checkboxPosition="before"
                           role="listitem" (click)="select3PLProvider(cmp)">
            <div class="row align-items-center no-gutters">
              <div class="col col-6 d-flex">
                <mat-radio-button [formGroup]="radioButton" [name]="cmp.name"
                                  [disabled]="companyProvidersCheck.selected && isDisabledRadio"
                                  [checked]="companyProvidersCheck.selected || cmp.eid === contract?.companyTPLEid"></mat-radio-button>
                <div>{{ cmp.name }}</div>
              </div>
              <div class="col-6">{{ cmp.eid }}</div>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>

      <ng-container *ngIf="error && !isLoading">
        <div class="border border-warning p-3">
          <div>
            <mat-icon class="text-warning" fontSet="fas" fontIcon="fa-exclamation-triangle"></mat-icon>
            Something went wrong, it was not possible to get information!
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && (!companyProviders || companyProviders.length === 0)">
        <div class="p-4 mt-4">
          <h5 class="text-muted d-flex justify-content-center">Search third party company by EID or Name</h5>
        </div>
      </ng-container>

      <div *ngIf="isLoading" class="overflow-hidden list-max-height">
        <ns-skeleton [type]="skeleton"></ns-skeleton>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <button mat-stroked-button matStepperPrevious color="accent" class="mr-3" aria-label="Previous Button" (click)="clearText()">
      Back
    </button>
    <button mat-flat-button matStepperNext color="accent" aria-label="Next Button" [disabled]="!isSelectedProvider"
            (click)="next()">
      Next
    </button>
  </div>
</div>
